import flatMap from 'lodash/flatMap';

export default function (...args) {
  return flatMap(args, op => ['Success', 'Error', 'Loading'].map(status => op + status));
}
